import TerminateSubmissionDialog from './TerminateSubmissionDialog';

export default TerminateSubmissionDialog;
